import axios from "axios";
import { getAuthToken } from "../Utils/helper";


//  for formData
export const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_LARAVEL_API_URL,
    headers: {
        // "Content-Type": "application/json",
        Authorization: `Bearer ${getAuthToken()}`,
    },
});

// for raw
export const axiosInstanceRow = axios.create({
    baseURL: process.env.REACT_APP_LARAVEL_API_URL,
    headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAuthToken()}`,
    },
});


// for auth
export const loginInstance = axios.create({
    baseURL: process.env.REACT_APP_LARAVEL_API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});



